var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import { Form, Error, IconButton } from "@brushfire/ui";
import FormikContextListener from "../../../Helpers/FormikContextListener";
import WidgetFieldset from "../../../Helpers/WidgetFieldset";
import { useLocation } from "react-router";
import { postEmail } from "../../../../data/api";
import ReCAPTCHA from "react-google-recaptcha";
import Constants from "../../../../data/constants";
import * as Yup from "yup";
import { clearInlineErrors, setFormIsSubmitting, setInlineError } from "../../../../store/AppState/actions";
import { useDispatch } from "react-redux";
import { handleErrors } from "../../../../data/helpers";
import InlineError from "../../../UI/InlineError";
import { LOCAL_STORAGE_KEYS, getLocal, setLocal } from "../../../../data/localStorageHelpers";
var EmailDirections = function (_a) {
    var _b, _c;
    var event = _a.event, close = _a.close, setShowSuccess = _a.setShowSuccess, showSuccess = _a.showSuccess, kioskEnabled = _a.kioskEnabled;
    var location = useLocation();
    var dispatch = useDispatch();
    var recaptchaRef = useRef();
    var emailDirectionsSchema = Yup.object().shape({
        from: Yup.string()
            .email("Please enter a valid email address.")
            .required("Email is required."),
        fromName: Yup.string().required("Name is required."),
        to: Yup.string().required("To is required."),
    });
    var onSubmit = function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var token, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    formikHelpers.setSubmitting(false);
                    return [4 /*yield*/, recaptchaRef.current.executeAsync()];
                case 1:
                    token = _b.sent();
                    values.recaptchaResponse = token;
                    formikHelpers.setSubmitting(true);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    formikHelpers.setSubmitting(false);
                    recaptchaRef.current.reset();
                    formikHelpers.setFieldError("recaptchaResponse", "Recaptcha is required.");
                    return [2 /*return*/];
                case 3:
                    dispatch(setFormIsSubmitting(true));
                    dispatch(clearInlineErrors());
                    if (!kioskEnabled) {
                        setLocal(LOCAL_STORAGE_KEYS.EMAIL, values.from);
                        setLocal(LOCAL_STORAGE_KEYS.NAME, values.fromName);
                    }
                    if (event) {
                        postEmail(event === null || event === void 0 ? void 0 : event.eventNumber, values)
                            .then(function () {
                            setTimeout(function () {
                                setShowSuccess(true);
                            }, 500);
                        })
                            .catch(function (e) {
                            var _a, _b, _c;
                            handleErrors(e, formikHelpers);
                            dispatch(setInlineError({
                                emailDirectionsError: (_b = (_a = e.response.data) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "An error occured while sending this email",
                            }));
                            (_c = recaptchaRef.current) === null || _c === void 0 ? void 0 : _c.reset();
                        })
                            .finally(function () {
                            dispatch(setFormIsSubmitting(false));
                            formikHelpers.setSubmitting(false);
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var initialValues = {
        from: (_b = getLocal(LOCAL_STORAGE_KEYS.EMAIL)) !== null && _b !== void 0 ? _b : "",
        fromName: (_c = getLocal(LOCAL_STORAGE_KEYS.NAME)) !== null && _c !== void 0 ? _c : "",
        body: "",
        to: "",
        type: 0,
        recaptchaResponse: "",
    };
    return (_jsxs("div", __assign({ className: "d-flex flex-column w-100" }, { children: [_jsx(InlineError, { id: "emailDirectionsError" }), showSuccess ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "d-flex align-items-center" }, { children: _jsx(IconButton, { icon: "arrow-left", ariaLabel: "Close", classes: "mr-1", onClick: function () {
                                setShowSuccess(false);
                                close();
                            } }) })), _jsxs("div", __assign({ className: "absolute-center ta-center" }, { children: [_jsx("h1", __assign({ className: "bold tt-uppercase mega m-bottom-medium" }, { children: "You're all set!" })), _jsx("h3", __assign({ className: "bold" }, { children: "Event directions have been successfully shared." }))] }))] })) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "d-flex align-items-center justify-content-between" }, { children: [_jsx("h4", __assign({ className: "semi-bold mb-0" }, { children: "Email Directions" })), _jsx(IconButton, { icon: "times", ariaLabel: "Close", classes: "", onClick: close })] })), _jsx(Form, __assign({ initialValues: initialValues, onSubmit: onSubmit, validationSchema: emailDirectionsSchema, formikBagProps: {
                            submitButtonLabel: "Send",
                        } }, { children: function (_a) {
                            var formikContext = _a.formikContext;
                            return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: location.pathname, path: location.pathname, formikContext: formikContext, active: true, initialValues: initialValues }), _jsxs(WidgetFieldset, { children: [_jsx(Form.Field, { label: "Your Name", name: "fromName", id: "fromName", isFieldRequired: true }), _jsx(Form.Field, { label: "Your Email Address", name: "from", id: "from", type: "email", isFieldRequired: true }), _jsx(Form.Field, { label: "To (separate up to 5 addresses with commas)", name: "to", id: "to", isFieldRequired: true }), _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: Constants.RecaptchaSiteKey, onChange: function (value) {
                                                    formikContext.setFieldValue("recaptchaResponse", value);
                                                }, size: "invisible" }), _jsxs("p", __assign({ className: "mini" }, { children: ["This site is protected by reCAPTCHA and the Google", " ", _jsx("a", __assign({ href: "https://policies.google.com/privacy" }, { children: "Privacy Policy" })), " and", " ", _jsx("a", __assign({ href: "https://policies.google.com/terms" }, { children: "Terms of Service" })), " apply."] })), formikContext.errors.recaptchaResponse && formikContext.submitCount > 0 && (_jsx(Error, { children: formikContext.errors.recaptchaResponse }))] })] }));
                        } }))] }))] })));
};
export default EmailDirections;
